// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__ekano","title":"FrontImage_title__2ogJU"};